/**
 * Veluna quick add.
 *
 * Turns any element carrying `data-vqa="<product-handle>"` into an add-to-cart
 * that opens the cart drawer, instead of a link to the product page.
 *
 * Owner decision 2026-09-21: "Start 30 nights" in the header and the hero
 * should open the drawer rather than the PDP. Both said "Start 30 nights" and
 * then made you land on a page and press a second button.
 *
 * PROGRESSIVE ENHANCEMENT, on purpose. The markup stays an <a href> pointing at
 * the product, and this only calls preventDefault once it is confident it can
 * do better. If the fetch fails, if the product has no purchasable variant, or
 * if this file never loads, the link still works and the shopper still reaches
 * a page where they can buy. A quick-add that silently does nothing is worse
 * than a link.
 *
 * The variant is resolved at click time from /products/<handle>.js rather than
 * baked into the markup, so it cannot go stale when variants change, and it
 * works from the header, which has no product context in Liquid.
 */
(function () {
  'use strict';

  var TERM = '1 Month';   // the entry variant; matches the hero's "30 nights" price

  function pickVariant(product) {
    var vs = (product && product.variants) || [];
    var available = vs.filter(function (v) { return v.available; });
    var pool = available.length ? available : vs;
    for (var i = 0; i < pool.length; i++) {
      if ((pool[i].title || '').indexOf(TERM) !== -1) { return pool[i]; }
    }
    return pool[0] || null;
  }

  function openDrawer() {
    if (window.VelunaCartDrawer && typeof window.VelunaCartDrawer.open === 'function') {
      window.VelunaCartDrawer.open();
      return true;
    }
    return false;
  }

  function handle(el, ev) {
    var slug = el.getAttribute('data-vqa');
    if (!slug) { return; }
    // Modified clicks are the shopper asking for a new tab. Leave them alone.
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button > 0) { return; }
    if (el.getAttribute('aria-busy') === 'true') { ev.preventDefault(); return; }

    ev.preventDefault();
    el.setAttribute('aria-busy', 'true');
    var restore = el.getAttribute('data-vqa-label') || el.textContent;

    fetch('/products/' + slug + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) { throw new Error('product lookup failed'); }
        return r.json();
      })
      .then(function (product) {
        var v = pickVariant(product);
        if (!v) { throw new Error('no purchasable variant'); }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        }).then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) { throw new Error(data.description || data.message || 'add failed'); }
            return data;
          });
        });
      })
      .then(function () {
        el.removeAttribute('aria-busy');
        el.textContent = restore;
        if (!openDrawer()) { window.location.href = '/cart'; }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        // Fall back to the behaviour the link always had.
        el.removeAttribute('aria-busy');
        el.textContent = restore;
        var href = el.getAttribute('href');
        window.location.href = (href && href !== '#') ? href : ('/products/' + slug);
      });
  }

  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-vqa]') : null;
    if (el) { handle(el, ev); }
  });
})();
